// extracted by mini-css-extract-plugin
module.exports = {"textData":"textData_textData__1E5ro","textItemData":"textData_textItemData__3PX7u"};